export default __webpack_public_path__ + "static/media/ccpa-privacyoptions.17269f1b.svg";